<template>
    <nav>
        <ul class="pagination justify-content-center flex-wrap">
            <!-- Previous Button -->
            <li class="page-item" :class="{ disabled: currentPage === 1 }">
                <a
                    class="page-link"
                    href="#"
                    @click.prevent="update(currentPage - 1)"
                >
                    {{ __('Previous') }}
                </a>
            </li>

            <!-- Page Numbers -->
            <li
                v-for="page in pagination"
                :key="page"
                class="page-item"
                :class="{ active: page === currentPage }"
            >
                <a
                    class="page-link"
                    href="#"
                    @click.prevent="update(page)"
                >
                    {{ page }}
                </a>
            </li>

            <!-- Next Button -->
            <li class="page-item" :class="{ disabled: currentPage === lastPage }">
                <a
                    class="page-link"
                    href="#"
                    @click.prevent="update(currentPage + 1)"
                >
                    {{ __('Next') }}
                </a>
            </li>
        </ul>
    </nav>
</template>

<script>
export default {
    props: ["results", "getData"],
    watch: {
        results: {
            immediate: true,
            handler: function(newVal, oldVal) {
                if (!oldVal || newVal.lastPage !== oldVal.lastPage) {
                    this.pagination = new Array(newVal.lastPage)
                        .fill(0)
                        .map((value, idx) => idx + 1);
                    this.currentPage = 1;
                    this.lastPage = newVal.lastPage;
                }
            }
        }
    },
    data() {
        return {
            pagination: [],
            currentPage: 1,
            lastPage: 1
        };
    },
    methods: {
        update(page) {
            if (page == 0 || page > this.lastPage) {
                return;
            }
            this.currentPage = page;
            this.$emit("update", page);
        }
    },
    mounted() {}
};
</script>